export class Contact {
	/**
	 * @constructor Contact constructor
	 * @param {object} contact - Contact object
	 * @property {string} email - an email.
	 * @property {string} firstname - a firstname.
	 * @property {string} lastname - a lastname.
	 * @property {number} civility - a civility.
	 * @property {string} phone - a phone.
	 * @property {string} password - a password.
	 * @property {number} role - a role.
	 * @property {number} status - a status.
	 * @property {string} commentary - a commentary.
	 * @property {number} type - a type
	 * @property {string} fonction - function of user in the society
	 * @property {number} hasAccess - If the user has access to the application.
	 * @property {number} societies_id - a society ID.
	 */
	constructor(contact) {
		this.email = contact.email;
		this.firstname = contact.firstname;
		this.lastname = contact.lastname;
		this.civility = contact.civility;
		this.phone = contact.phone;
		this.password = contact.password;
		this.role = contact.role || 2;
		this.status = contact.status || 0;
		this.commentary = contact.commentary;
		this.type = contact.type;
		this.fonction = contact.fonction || null;
		this.hasAccess = contact.hasAccess;
		this.societies_id = contact.societies_id;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} contact object
	 */
	static getFormFields(){
		return {
			email: null,
			firstname: null,
			lastname: null,
			civility: null,
			phone: null,
			password: null,
			role: 2,
			status: 0,
			commentary: null,
			type: null,
			fonction: null,
			hasAccess: null,
			societies_id: null
		};
	}

	compare(contactToCompare){
		for(let key in contactToCompare) {
			if(this[key] != contactToCompare[key]){
				return false;
			}
		}
		return true;
	}
}
